import { NAV_PATHS } from '@modules/common/constants';
import { IntegrationSourceListByType } from '@modules/integrationsV2/components/IntegrationsContainer/IntegrationsSourceList/IntegrationSourceListByType';
import { useGetIntegrationsPageContentHeight } from '@modules/integrationsV2/hooks';
import { IntegrationSource } from '@modules/integrationsV2/types';
import { Box, Stack } from '@mui/material';
import { IntegrationType } from 'generated/graphql';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface IntegrationsSourceListProps {
  integrationSourcesGroupedByType: Record<IntegrationType, IntegrationSource[]>;
  selected: IntegrationSource | undefined;
}

export const IntegrationsSourceList = (props: IntegrationsSourceListProps) => {
  const height = useGetIntegrationsPageContentHeight({
    defaultHeight: '90vh',
  });
  const navigate = useNavigate();

  useEffect(() => {
    const integrationSource = props.selected;
    const integrationSourceID = `${integrationSource?.eqlFieldsGroupID}+${integrationSource?.integrationType}`;

    navigate(
      `/${NAV_PATHS.SETTINGS_INTEGRATIONS}/${encodeURIComponent(
        integrationSourceID,
      )}`,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      width="25vw"
      maxWidth={380}
      minWidth={300}
      sx={{
        borderRight: '1px solid',
        borderColor: 'divider',
        height,
        overflowY: 'auto',
        pt: 3,
      }}
    >
      <Stack spacing={3}>
        <IntegrationSourceListByType
          integrationType={IntegrationType.Feedback}
          {...props}
        />
        <IntegrationSourceListByType
          integrationType={IntegrationType.User}
          {...props}
        />
        <IntegrationSourceListByType
          integrationType={IntegrationType.Account}
          {...props}
        />
        <IntegrationSourceListByType
          integrationType={IntegrationType.Cohorts}
          {...props}
        />
      </Stack>
    </Box>
  );
};
